import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { VerifyEmailComponent } from './pages/verify-email/verify-email.component';

@NgModule({
    declarations: [VerifyEmailComponent],
    imports: [CommonModule, RouterModule],
})
export class VerifyEmailModule {}
